module.exports = __webpack_public_path__ + "static/media/no_people.09fa978d.png";